import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from '../Directives';
import { CognitiveAssessmentImageComponent } from './CognitiveAssessmentImage.component';

export const CognitiveAssessmentImageModuleExports = [
    CognitiveAssessmentImageComponent
];

@NgModule({
    imports: [CommonModule, DirectivesModule],
    declarations: [...CognitiveAssessmentImageModuleExports],
    exports: [...CognitiveAssessmentImageModuleExports],
    providers: []
})
export class CognitiveAssessmentImageModule {}
